import Vue from 'vue'
import Router from 'vue-router'
import Nav from '@/components/public/nav'
import index from '@/components/page/index'
import recommend from '@/components/page/recommend'
import ancientBooks from '@/components/page/ancientBooks'
import bookDetail from '@/components/page/bookDetail'
import about from '@/components/page/about'
// import login from '@/components/page/login_standby'
import login from '@/components/page/login'
import viewpicture from '@/components/page/viewpicture2'
import search from '@/components/page/search'
import cooperate from '@/components/page/cooperate'
import books from '@/components/page/books'
import bookMarks from '@/components/page/bookMarks'
import bookTags from '@/components/page/bookTags_standby'
import community from '@/components/page/community'
import questionDetails from '@/components/page/questionDetails'
import myquestion from '@/components/page/myquestion'
import messagecenter from '@/components/page/messagecenter'
import doctorDetail from '@/components/page/doctorDetail'
import doctor from '@/components/page/doctor'
import personal from '@/components/page/personal'


Vue.use(Router)

export default new Router({
	fallback: false,
	mode: 'history',
	routes: [{
		path: '/',
		component: Nav,
		meta: {
			title: "首页"
		},
		children: [{
			path: '/index',
			component: index,
			meta: {
				title: "首页",
				auth: false,
				keepAlive:true
			}
		}, {
			path: '/recommend',
			component: recommend,
			meta: {
				title: "热门推荐",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/ancientBooks',
			component: ancientBooks,
			name:'ancientBooks',
			meta: {
				title: "古籍分类",
				auth: false,
				keepAlive:false
			},
		}, {
			path: '/bookDetail',
			component: bookDetail,
			meta: {
				title: "古籍分类详情",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/about',
			component: about,
			meta: {
				title: "关于我们",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/community',
			component: community,
			name:'community',
			meta: {
				title: "社区",
				auth: true,
				keepAlive:true
			}
		}, {
			path: '/questionDetails',
			component: questionDetails,
			meta: {
				title: "问题详情",
				auth: true,
				keepAlive:true
			}
		}, {
			path: '/messagecenter',
			component: messagecenter,
			meta: {
				title: "消息中心",
				auth: true,
				keepAlive:false
			}
		}, {
			path: '/myquestion',
			component: myquestion,
			meta: {
				title: "我的问题",
				auth: true,
				keepAlive:false
			}
		}, {
			path: '/search',
			component: search,
			meta: {
				title: "搜索",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/doctorDetail',
			component: doctorDetail,
			meta: {
				title: "名医工作室",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/doctor',
			component: doctor,
			meta: {
				title: "名医工作室详情",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/login',
			name:'login',
			component: login,
			meta: {
				title: "登录",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/books',
			component: books,
			meta: {
				title: "我的书籍",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/personal',
			component: personal,
			meta: {
				title: "个人中心",
				auth: true,
				keepAlive:false
			}
		}, {
			path: '/cooperate',
			component: cooperate,
			meta: {
				title: "商务合作",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/bookMarks',
			component: bookMarks,
			meta: {
				title: "我的书签",
				auth: false,
				keepAlive:false
			}
		}, {
			path: '/bookTags',
			component: bookTags,
			meta: {
				title: "我的书签",
				auth: false,
				keepAlive:false
			}
		}],
		redirect: '/index'
	}, {
		path: '/picture',
		component: viewpicture,
		meta: {
			title: "查看图片",
			auth: true,
			keepAlive:false
		},
	}]
})


// WEBPACK FOOTER //
// ./src/router/index.js